import React, { Component } from 'react';
import { connect } from 'react-redux';

import NoData from '../../../components/NoData/NoData';

import { DatePicker, Options } from '../../../components/Filter/components';
import DashboardInfo from '../../../components/DashboardInfo/DashboardInfo';

import CTSPChart from './CTSPChart';
import DetailedOverview from './DetailedOverview';
import PercentilesTrendChart from './PercentilesTrendChart';
import DetailsAccordion from '../../../components/DetailsAccordion/DetailsAccordion';

import '../CTSP.scss';

class WallboardCTSPChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {}
    };
  }

  handlePointClick = point => {
    this.setState({
      selectedPoint: point
    });
  };

  render() {
    return (
      <div className="content-wrap">
        <div className="dashboard_head">
          <div className='title-info'>
            <p>Cycle Time Scatterplot</p>
            <DashboardInfo dashboard={this.props.dashboard} />
          </div>
          <div className="button_tools">
            <Options chart="ctsp" showMetrics showLineChart options={{ lineChartTooltip: 'Percentiles chart' }} />
            <DatePicker />
          </div>
        </div>
        <div>
          <div className="dashboard_details">
            {this.props.data.series && !!this.props.data.series.length && (
              <DetailedOverview id="details" data={this.props.data.series} />
            )}
            {this.props.lineChart && <PercentilesTrendChart data={this.props.percentileTrends} />}
            <DetailsAccordion id="details-accordion" data={this.state.selectedPoint} />
          </div>
          <div className="diagram_details">
            <CTSPChart id="CTSP" data={this.props.data} onPointClick={this.handlePointClick} />
            <NoData show={this.props.data.series && !this.props.data.series.length} loading={this.props.isLoading} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    lineChart: state.filters.ctsp.lineChart,
    data: state.ctsp.data,
    percentileTrends: state.ctsp.percentileTrends,
    isLoading: state.ctsp.isLoading,
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps)(WallboardCTSPChart);
